// 登录相关API接口
import request from "@/utils/request"
// 向外按需导出一个API函数
export const loginAPI = function (loginForm) {
    return request.post('/login',loginForm)
     // return loginForm
}

/**
 * 忘记密码提交
 * @param data
 * @returns {*}
 */
export function forget(data) {
    return request({
        url: '/forget',
        method: 'post',
        data
    })
}
